import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="What you get" className="border-y border-grape/10 bg-white/70" data-id="element-241" data-mp="2wxqc25ic86f9">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "10px",
      paddingBottom: "10px"
    }} data-id="element-242" data-mp="2wvdx817vmc6f">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-243" data-mp="2nws7nm3zlww5">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-244" data-mp="2nyv6mvn4b0d0">
              <dt className="font-display text-4xl font-black text-plum sm:text-5xl" data-id="element-245" data-mp="297ciubo0o1j3">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-246" data-mp="2dznrq40qixns">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}